import {
  Formatters
} from 'guaxinim-web'

const formatos = {
  '%': val => Formatters.percentAbbreviationFormat(val),
  '$': val => Formatters.currencyAbbreviationFormat(val),
  'D': val => Formatters.decimalAbbreviationFormat(val),
  'I': val => Formatters.integerAbbreviationFormat(val)
}

const defineIcone = (valor)  => {
  if (valor > 0)
    return 'fa fa-caret-up'
  else if (valor < 0)
    return 'fa fa-caret-down'
}
const formataValor = (valor, formato) => formatos[formato] ? formatos[formato](valor) : valor
const formataCor = ( valor, melhorResultado ) => {
  if ( valor === 0 )
    return

  if (((melhorResultado === '+') &&  (valor > 0))
    || (( melhorResultado === '-' ) && (valor < 0))) {
    return {
      'positive': true
    }
  }
  else if (((melhorResultado === '+') && (valor < 0))
      ||(melhorResultado === '-') && (valor > 0)) {
    return {
      'negative': true
    }
  }
}

export default {
  defineIcone,
  formataValor,
  formataCor
}
